import { Typography } from "@mui/material";
import { RadioButtonsSkeleton } from "Components/Licenses/CountrySelector/RadioButtonsSkeleton";
import type { LicenseSelectionModel } from "Components/Licenses/LicenseOrderForm/schema";
import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { useRegionList } from "Hooks/Options/useRegionList";
import type { Region } from "Infrastructure/Api/Api";
import type { Control } from "react-hook-form";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.CountrySelector;

type CountrySelectorProps = {
  control: Control<LicenseSelectionModel>;
  isDisabled: boolean;
  onRegionChange?: (region: Region) => void;
};

export const CountrySelector = ({
  control,
  isDisabled,
  onRegionChange,
}: CountrySelectorProps) => {
  const { t } = useResource();
  const { codeListRegions, isLoading, isError } = useRegionList();

  if (isLoading) {
    return <RadioButtonsSkeleton />;
  }

  if (isError || codeListRegions.length === 0) {
    return (
      <Typography color="error.main">{t(RESOURCES.LoadingError)}</Typography>
    );
  }

  return (
    <Dropdown
      name="region"
      label={t(RESOURCES.Label)}
      disabled={isDisabled}
      control={control}
      codeList={codeListRegions}
      onChange={(value) => onRegionChange?.(value as Region)}
    />
  );
};
